import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dealer-invoice-import-dialog" }
const _hoisted_2 = { class: "upload-area" }
const _hoisted_3 = {
  class: "action-links",
  style: {"display":"flex","align-items":"center","gap":"12px","margin-bottom":"12px"}
}
const _hoisted_4 = { class: "dragger-upload-zone" }
const _hoisted_5 = { class: "ant-upload-drag-icon" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "点击或将文件拖拽到此区域上传", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-hint" }, "仅支持 .xlsx / .xls 格式，按“开票单编码”分组导入指定开票内容", -1)
const _hoisted_8 = {
  key: 0,
  class: "uploaded-file-info",
  style: {"margin-top":"8px","color":"#52c41a","font-size":"13px"}
}
const _hoisted_9 = {
  key: 0,
  class: "validate-result",
  style: {"margin-top":"12px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"600","margin-bottom":"8px"} }, "导入结果", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InboxOutlined = _resolveComponent("InboxOutlined")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createBlock(_component_oio_modal, {
    visible: _ctx.dialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "导入指定开票内容",
    width: "720px",
    "confirm-loading": _ctx.importLoading,
    "ok-text": "开始导入",
    "enter-callback": _ctx.handleImportConfirm,
    "cancel-callback": _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadTemplate && _ctx.handleDownloadTemplate(...args))),
              class: "download-template-link"
            }, "下载模板")
          ]),
          _createVNode(_component_FileUpload, {
            value: _ctx.fileValue,
            limit: 1,
            accept: ".xlsx,.xls",
            onChange: _ctx.handleFileChange,
            onRemove: _ctx.handleFileRemove
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, [
                  _createVNode(_component_InboxOutlined)
                ]),
                _hoisted_6,
                _hoisted_7
              ])
            ]),
            _: 1
          }, 8, ["value", "onChange", "onRemove"]),
          (_ctx.uploadedFile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " ✓ 已上传：" + _toDisplayString(_ctx.uploadedFile.name), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.resultMessages.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_a_table, {
                columns: _ctx.messageColumns,
                "data-source": _ctx.resultMessages,
                pagination: false,
                size: "small",
                bordered: "",
                scroll: { y: 220 }
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'level')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        style: _normalizeStyle({ color: record.level === 'ERROR' ? '#ff4d4f' : '#52c41a' })
                      }, _toDisplayString(record.level === 'ERROR' ? '错误' : '成功'), 5))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "data-source"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading", "enter-callback", "cancel-callback"]))
}